import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import React from "react";
import clientComponent from "../../../config/clientComponents";
import { slugify } from "../../../utils/string";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const GenericFilter = ({
  filters,
  filterName,
  filtersState,
  setFiltersState,
  setSelectedInstitution,
  index,
  filtersKeys,
}) => {
  const { t, i18n } = useTranslation();
  let itemDiv = "";

  //----------- Styling filter layout depending on the filter (to change)

  let typeFilters = [];
  const [isOpen, setIsOpen] = useState(false);
  const [valueRange, setValueRange] = useState(0)
  const [valueInput, setValueInput] = useState("")
  const filterSearchRef = useRef(null);
  const [filtersSearch, setFiltersSearch] = useState("");

  useEffect(() => {
    if (filters[filterName]["typeFilter"] === "button") {

      setFiltersSearch(filters[filterName]["selected"])
    } else if (filters[filterName]["typeFilter"] === "budget" && filters[filterName]["slug"] === "budget_max" && filters[filterName]["selected"] !== 0) {
      setValueInput(filters[filterName]["selected"])
    }
  }, [])

  const filterNameCommune = "bien_ville";
  const filterNameRangeDistance = "distance_max";

  useEffect(() => {
    if (filtersState[filterNameCommune]?.length !== 1 && filterName === filterNameRangeDistance) {
      setValueRange(0);
    }
  }, [filtersState[filterNameCommune], filterName]);

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  //--- Dynamic Import
  const FilterItem = clientComponent["FilterItem"];

  typeFilters = filters[filterName]["values"].map((filter, i) => {
    if (filtersSearch) {
      if (filter.slug.includes(slugify(filtersSearch))) {
        return (
          <FilterItem
            key={filterName + filter.id}
            filter={filter}
            filtersState={filtersState}
            filterName={filterName}
            setFiltersState={setFiltersState}
            itemDiv={itemDiv}
            filters={filters}
            setSelectedInstitution={setSelectedInstitution}
            filtersKeys={filtersKeys}
          />
        );
      }
    } else {
      return (
        <FilterItem
          key={filterName + filter.id}
          filter={filter}
          filtersState={filtersState}
          filterName={filterName}
          setFiltersState={setFiltersState}
          itemDiv={itemDiv}
          filters={filters}
          setSelectedInstitution={setSelectedInstitution}
          filtersKeys={filtersKeys}
        />
      );
    }
  });

  const handleChange = (e) => {
    setFiltersSearch(e.target.value);
  };

  const emptySearchbar = () => {
    filterSearchRef.current.value = "";
    setFiltersSearch("");
  };

  // Custom Filter for Range price
  const handleFilter = (value) => {

    let slugifiedName = "";
    //--- Reset selected Institution on filter input
    setSelectedInstitution(null);

    //--- get the slug corresponding to the name
    for (const filter of filters[filterName].values) {
      if (parseFloat(filter.slug) <= parseFloat(value)) {
        slugifiedName = filter.slug;
      }
    }
    //--- Add or remove the filter slug into filterState
    if (slugifiedName.length > 0) {
      setFiltersState((prevfilter) => ({
        ...prevfilter,
        [filterName]: [slugifiedName],
      }));
    } else {
      setFiltersState((prevfilter) => ({
        ...prevfilter,
        [filterName]: []
      }));
    }
  };

  const handleFilterinput = (value) => {

    //--- Reset selected Institution on filter input
    setSelectedInstitution(null);
    // check value max budget = 0
    if (value === 0 && filters[filterName].slug === "budget_max") {
      value = filters[filterName].values[0].slug
    }

    //--- Add or remove the filter slug into filterState
    setFiltersState((prevfilter) => ({
      ...prevfilter,
      [filterName]: [value]
    }));
  };

const handleFilterButton = (id) => {

  let slugifiedName = "";

  // Reset selected Institution on filter input
  setSelectedInstitution(null);

  // Récupération du slug correspondant au nom
  for (const filter of filters[filterName].values) {
    if (id === filter.name) {
      slugifiedName = filter.slug;
    }
  }

  setFiltersState((prevFilter) => {
    const newState = {
      ...prevFilter,
      [filterName]: slugifiedName.length > 0 ? [slugifiedName] : [],
    };

    const currentTypeSlug = prevFilter.type_slug || [];
    if (id === "Terrain à bâtir") {
      if (!currentTypeSlug.includes("terrain")) {
        newState.type_slug = [...currentTypeSlug, "mon-terrain"];
      } else {
        newState.type_slug = currentTypeSlug;
      }
    } else {
      newState.type_slug = currentTypeSlug.filter((slug) => slug !== "mon-terrain");
    }

    return newState;
  });
};



  const FilterRange = () => {
    return (
      <div className="slider-container">
        <p className="slider-label">{filters[filterName]["title"]}</p>
        <input
          type="range"
          disabled={isDisabledFilterDistance}
          step="1"
          min="0"
          max={steps.length - 1}
          value={valueRange}
          onChange={(e) => {
            handleFilter(steps[e.target.value]); setValueRange(e.target.value)
          }}
          className="slider"
        />
        <p className="slider-value">{steps[valueRange]} {filterName === "distance_max" ? "km" : '€'}</p>
        {
          isDisabledFilterDistance
            ? <p className="slider-error-message">
              {messageErrorRange}
            </p>
            : null
        }
      </div>
    )
  }

  const FilterButton = () => {
    return (
      <div className={`generic-filter-button-container`} >
        {
          filters[filterName]["values"].map((item) => {
            const defaultActive = (filtersState.filter?.length === 0 || filtersState.filter === undefined) && item.slug === "all"
            return (
             <button
                className=
                {`generic-filter-button 
                ${(filtersState.filter?.includes(item.slug) && item.slug !== "programme") || defaultActive ? "active" : ""}
                ${(filtersState.filter?.includes(item.slug) && filtersState.type_slug?.includes("mon-terrain")) && item.id === 4 ? `active` : ""}
                     ${(filtersState.filter?.includes(item.slug) && !filtersState.type_slug?.includes("mon-terrain")) && item.id === 2 ? `active` : ""}
                `}
                key={item.id}
                onClick={() => handleFilterButton(item.name)}>
                {item.name}
              </button>

            )
          })
        }
      </div>
    )
  }
  const FilterDeffault = () => {

    const activeType = filtersState.filter?.[0]

    return (
      <>
        {!filters[filterName]["isSubFilter"] && filters[filterName]["title"] && (
          <div className={`generic-filter 
          ${filters[filterName]["title"] === "Type" 
            && Object.hasOwn(filtersState, "filter") 
            && activeType ? slugify(activeType) : "all-types"} 
            ${filtersState.type_slug?.includes("mon-terrain") ? filtersState.type_slug[0] : ""}
            ${isOpen ? "open" : ""}`}>
            <div onClick={() => handleOpen()} className="generic-filter__title">
              {filters[filterName]["title"]}
            </div>
            <div className="items__wrapper" style={{ display: "none" }}>
              {filters[filterName]["isSearchable"] && (
                <div className="subfilters-search__wrapper">
                  <span className="iconReactLeafletsearch"></span>
                  <input
                    className="subfilters-search"
                    type="text"
                    onChange={(e) => {
                      handleChange(e)
                    }
                    }
                    placeholder={`${t("searchFrom")} ${filters[filterName].title
                      }`}
                    ref={filterSearchRef}
                  />
                  {filtersSearch && (
                    <span
                      onClick={emptySearchbar}
                      className="icon iconReactLeafletx"
                    ></span>
                  )}
                </div>
              )}{" "}
              <div className="items__wrapper-inner">
                <OverlayScrollbarsComponent
                  className="overlay-scrollbar os-theme-dark items__wrapper-inner-scroll-container"
                  options={{
                    overflowBehavior: {
                      x: "hidden",
                      y: "scroll",
                    },
                  }}
                // ref={scrollbarRef}
                >
                  {typeFilters}
                </OverlayScrollbarsComponent>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  const SwitchFilter = ({ type }) => {
    switch (type) {
      case 'button':
        return <FilterButton />
      case 'range':
        return <FilterRange />
      case 'select':
        return <FilterDeffault />
      default:
        return <></>
    }
  }


  const steps = [0, ...filters[filterName].values.map(value => value.slug)];
  let isDisabledFilterDistance = filtersState?.bien_ville?.length !== 1 && filters[filterName].slug === 'distance_max'
  const messageErrorRange = filtersState?.bien_ville?.length === 0 ? "Veuillez choisir une commune"
    : filtersState?.bien_ville?.length > 1 ? "Trop de communes sélectionnées" : ""
  let debounceTimeout
  return (
    <React.Fragment key={filterName}>
      {/* {index < 1 || filtersState[filtersKeys[0]]?.includes(filters[filterName]["slug"]) ? ( */}
      {/* {index < 1 ? (
        <> */}
      {/* {!filters[filterName]["isSubFilter"] && (
        <> */}
      {
        filters[filterName]['typeFilter'] === "budget" ? (
          <div className="input-container">
            <p className="input-label">{filters[filterName]["title"]}</p>
            <input
              type="number"
              value={valueInput}
              onChange={(e) => {
                const newValue = Math.max(0, e.target.value);
                setValueInput(newValue)

                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(() => {
                  handleFilterinput(newValue);
                }, 1500);
              }}
              placeholder={filters[filterName]['slug'] === "budget_min" ? "Budget minimum" : "Budget maximum"}
              className="input"
              min="0"
            />
            <span className="input-unite">€</span>
          </div>
        ) :
          (
            <SwitchFilter type={filters[filterName]["typeFilter"]} />
          )

      }
      {/* </>
      )} */}
      {/* </>
      ) : (
        <></>
      )} */}
    </React.Fragment>
  );
};
export default GenericFilter;
